import { cx } from "../../lib/cx.js";
export function createAutocompleteDetachedContainerComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompleteDetachedContainer(userProps) {
    var children = userProps.children,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames;
    return createElement("div", {
      className: cx('ais-AutocompleteDetachedContainer', classNames.detachedContainer),
      onMouseDown: function onMouseDown(event) {
        event.stopPropagation();
      }
    }, children);
  };
}